<div id="updateAntennaInstanceDiv" class="modal modal-lg modal-dialog fade in" style="display: none;" appDraggable dragTarget="#updateAntennaInstanceDiv" dragHandle="#antennaInstanceDialogHeader">

	<div class="modal-content">

		<!-- Dialog Header -->
		<div class="modal-header" id="antennaInstanceDialogHeader">
			<button type="button" class="close"  data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-times" aria-hidden="true"></i></button>

			<div *ngIf="isNewDialog()">
				<h4 class="modal-title"><i class="fa fa-plus"></i> CREATE NEW {{instanceTypeName}}</h4>
			</div>
			<div *ngIf="isEditDialog()">
				<h4 class="modal-title"><i class="fa fa-refresh"></i> UPDATE: {{instanceTypeName}}</h4>
			</div>
		</div>

		<!-- Dialog Body -->
		<div class="modal-body">

			<!-- Tab Navigation Panel -->
			<ul class="nav nav-tabs">
				<li class="active"><a data-toggle="tab" href="#antennaInstanceInformation" aria-expanded="true">INFORMATION</a></li>
				<li *ngIf="isEditDialog() && (isEntityType_ReaderInstance() || isEntityType_AntennaInstance() || isEntityType_LocationInstance() || isEntityType_ObjectInstance() || isEntityType_ServiceInstance() || isEntityType_TagInstance() || isEntityType_ZoneInstance())" class=""><a data-toggle="tab" href="#entityInstanceFunctionsTab" aria-expanded="false">FUNCTIONS</a></li>
				<li class=""><a data-toggle="tab" href="#antennaInstanceData" aria-expanded="false" (click)="refreshInstanceDataClicked()">ADDITIONAL PARAMETERS</a></li>
			</ul>

			<!-- Tabs -->
			<div class="tab-content" style="height: 400px; overflow-y: auto; overflow-x: hidden" *ngIf="instance != null">

				<!-- Entity Instance Information Tab -->
				<div class="tab-pane fade active in" id="antennaInstanceInformation">
					<div class="pageContent">

						<!-- ID -->
						<div class="row" *ngIf="isEditDialog()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Id</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="instance.id" disabled /></div>
							</div>
						</div>

						<!-- Entity Type -->
						<div class="row">
							<label class="col-sm-4 labelRequired">{{instanceTypeName}} Type</label>
							<span class="col-sm-8">
								<select class="form-control" [(ngModel)]="instanceEntityType" (change)="selectedEntityTypeChanged()">
									<option [ngValue]="null"> -- Choose -- </option>
									<option *ngFor="let entityType of availableEntityTypes" [ngValue]="entityType">
										{{entityType.name}}
									</option>
								</select>
							</span>
						</div>

						<!-- Name -->
						<div class="row">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Name</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="instance.name" /></div>
							</div>
						</div>

						<!-- Description -->
						<div class="row">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Description</label></div>
								<div class="col-sm-8"><textarea rows="4" cols="40" class="form-control" id="description" [(ngModel)]="instance.description" ></textarea></div>
							</div>
						</div>

            <!-- Tag "Is Deactivated" -->
					  <div class="row" *ngIf="isEntityType_TagInstance()">
              <div class="form-group">
                <div class="col-sm-4"><label class="labelNormal">Is Deactivated?</label></div>
                <div class="col-sm-8">
                  <input class="form-control" type="checkbox" [(ngModel)]="instance.is_deactivated" [readonly]="isNewDialog()" [disabled]="isNewDialog()">
                </div>
              </div>
            </div>

						<!-- Image -->
						<div class="row" *ngIf="!isEntityType_ServerObjectInstance() && !isEntityType_DriverObjectInstance() && !isEntityType_ServiceInstance()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Image</label></div>
								<div class="col-sm-8">
									<button class="btn btn-ef" type="button" (click)="changeImageClicked()" style="width: 150px; margin-right: 20px; margin-bottom: 2px">CHANGE IMAGE</button>
									<input type="file" #instanceImage (change)="onImageFileChanged($event)" style="display:none" accept=".gif,.jpg,.png"/>
									<img [src]="imageSource()" style="max-width: 40px; max-height: 40px" />
								</div>
							</div>
						</div>

						<!-- Icon -->
						<div class="row" *ngIf="!isEntityType_ServerObjectInstance() && !isEntityType_DriverObjectInstance() && !isEntityType_LocationInstance() && !isEntityType_ZoneInstance() && !isEntityType_ServiceInstance()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Icon</label></div>
								<div class="col-sm-8">
									<button class="btn btn-ef" type="button" (click)="changeIconClicked()" style="width: 150px; margin-right: 20px; margin-bottom: 2px">CHANGE ICON</button>
									<input type="file" #instanceIcon (change)="onIconFileChanged($event)" style="display:none" accept=".gif,.jpg,.png"/>
									<img [src]="iconSource()" style="max-width: 40px; max-height: 40px" />
								</div>
							</div>
						</div>

						<!-- Object Instance (ASSET / PEOPLE) - Perimeter Radius -->
						<div class="row" *ngIf="isEntitySubType_Asset() || isEntitySubType_People()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Perimeter Radius</label></div>
								<div class="col-sm-8"><input class="form-control" type="number" [(ngModel)]="instance.perimeterRadius" /></div>
							</div>
						</div>

						<!-- Antenna Instance - Reader -->
						<div class="row" *ngIf="isEntityType_AntennaInstance()">
							<label class="col-sm-4 labelNormal">Reader</label>
							<span class="col-sm-8">
								<select style="color: #000000" [(ngModel)]="selectedReader" (change)="selectedReaderChanged()">
									<option [ngValue]="null"> -- Choose -- </option>
									<ng-container *ngIf="availableReaders != null">
										<option *ngFor="let reader of availableReaders" [ngValue]=reader>
											{{reader.name}}
										</option>
									</ng-container>
								</select>
							</span>
						</div>

						<!-- Antenna Instance - Port -->
						<div class="row" *ngIf="isEntityType_AntennaInstance()">
							<div class="form-group">
								<div class="col-sm-4"><label>Port</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="instance.port" /></div>
							</div>
						</div>

						<!-- Antenna Instance - Power Level -->
						<div class="row" *ngIf="isEntityType_AntennaInstance()">
							<div class="form-group">
								<div class="col-sm-4"><label>Power Level %</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="instance.powerLevel" /></div>
							</div>
						</div>

						<!-- Reader/Zone Instance - Location -->
						<div class="row" *ngIf="isEntityType_ReaderInstance() || isEntityType_ZoneInstance()">
							<label class="col-sm-4 labelNormal">Location</label>
							<span class="col-sm-8">
								<select style="color: #000000" [(ngModel)]="selectedLocation" (change)="selectedLocationChanged()">
									<option [ngValue]="null"> -- Choose -- </option>
									<ng-container *ngIf="availableLocations != null">
										<option *ngFor="let location of availableLocations" [ngValue]="location">
											{{location.name}}
										</option>
									</ng-container>
								</select>
							</span>
						</div>

						<!-- Location Instance - Parent Location -->
						<div class="row" *ngIf="isEntityType_LocationInstance()">
							<label class="col-sm-4 labelNormal">Parent Location</label>
							<span class="col-sm-8">
								<select style="color: #000000" [(ngModel)]="selectedLocation" (change)="selectedLocationChanged()">
									<option [ngValue]="null"> -- Choose -- </option>
									<ng-container *ngIf="availableLocations != null">
										<option *ngFor="let location of availableLocations" [ngValue]="location">
											{{location.name}}
										</option>
									</ng-container>
								</select>

							</span>
						</div>

						<!-- Asset Instance - Tag -->
						<div class="row" *ngIf="isEntitySubType_Asset() || isEntitySubType_People() ">
							<span class="col-sm-4"><label class="labelNormal">Tag</label></span>
							<span class="col-sm-8" id="tagDropDownDiv">
                <angular2-multiselect [data]="multiSelectTagDropDownList"
                                      [(ngModel)]="multiSelectTagSelectedItems"
                                      [settings]="multiSelectTagDropDownSettings"
                                      (onSelect)="selectTagItem($event)"
                                      (onDeSelect)="deselectTagItem($event)"
                                      (onSelectAll)="selectAllTagItems()"
                                      (onDeSelectAll)="deselectAllTagItems()">
                </angular2-multiselect>

								<!--<select style="color:black" [(ngModel)]="selectedTag" (change)="selectedTagChanged()">
									<option [ngValue]="null"> -- Choose -- </option>
									<ng-container *ngIf="availableTags != null">
										<option *ngFor="let tag of availableTags" [ngValue]="tag">
											{{tag.name}}
										</option>
									</ng-container>
								</select> -->
							</span>
						</div>

						<!-- Groups -->
						<div class="row">
							<div class="form-group" *ngIf="isEditDialog() || instance.groups != null">
								<div class="col-sm-4"><label class="labelNormal">Groups</label></div>
								<div class="col-sm-8">
									<ng-container *ngIf="instance.groups != null">
										<ng-container *ngFor="let group of instance.groups">
											<button class="groupButton" (click)="showGroupClicked(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</div>
              </div>
            </div>
          </div>
      </div>



				<!-- Instance Function(s) Tab -->
				<div *ngIf="isEditDialog() && (isEntityType_ReaderInstance() || isEntityType_AntennaInstance() || isEntityType_LocationInstance() || isEntityType_ObjectInstance() || isEntityType_ServiceInstance() || isEntityType_TagInstance() || isEntityType_ZoneInstance())" class="tab-pane fade" id="entityInstanceFunctionsTab">
					<ng-container *ngIf="instanceEntityType != null && instanceEntityType.functions != null">
						<div class="pageContent">
							<div class="row">
								<span id="objectFunctions">
									<ng-container *ngFor="let function of instanceEntityType.functions">
										<app-instance-function [instanceType]="instanceType" [instance]="instance" [function]="function" (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully($event)" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-instance-function>
									</ng-container>
								</span>
							</div>
						</div>
					</ng-container>
				</div>



				<!-- Instance Data Tab -->
				<div class="tab-pane fade" id="antennaInstanceData">
					<div id="newParamsDiv">
						<ng-container *ngIf="propertyDataUis == null || propertyDataUis.length == 0">
							No additional parameters
						</ng-container>
						<ng-container *ngIf="propertyDataUis != null && propertyDataUis.length > 0">
							<ng-container *ngFor="let propertyDataUi of propertyDataUis">
								<app-property-data-infrastructure [data]="propertyDataUi.mData" [property]="propertyDataUi.mProperty" [isCreate]="isNewDialog()"></app-property-data-infrastructure>
							</ng-container>
						</ng-container>
					</div>
					<div *ngIf="isEditDialog()" ><button class="btn btn-ef" (click)="refreshInstanceDataClicked()">Refresh</button></div>
				</div>
			</div>
		</div>

		<!-- Dialog Footer -->
		<div class="modal-footer">
			<button type="button" class="btn btn-default" (click)="hideDialog()"><i class="fa fa-ban"></i> CANCEL</button>
			<button *ngIf="isNewDialog()"  (click)="createOrUpdateClicked()" class="btn btn-primary"><i class="fa fa-plus"></i> CREATE</button>
			<button *ngIf="isEditDialog()" (click)="createOrUpdateClicked()" class="btn btn-primary"><i class="fa fa-refresh"></i> UPDATE</button>
		</div>
	</div>
</div>

<app-function-executing-dialog #functionExecutingDialog></app-function-executing-dialog>
<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
